<template>
  <div class="slice_mailer">
    <Loading :is-progress="isProgress" />
    <div
      v-show="isPopup"
      class="popup"
    >
      <div class="popup-data">
        <label for="menuName">
          <b>Enter Number Of Slices</b>
        </label>
        <br>
        <br>
        <input
          v-model="sliceCount"
          type="number"
          min="1"
          name="menuName"
          required
          class="slices_number"
        >
        <div class="btns-container">
          <button @click="sliceToCrop()">
            Ok
          </button>
          <button @click="cancel()">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <div
      v-show="isCtxMenu"
      v-click-outside="hideCtxMenu"
      contextmenu="mymenu"
    >
      <ul :style="`left:${xCoords}px;top:${yCoords}px;position:absolute;z-index:777`">
        <li>
          <a @click="showPopup()">Slice and Crop</a>
        </li>
      </ul>
    </div>
    <div class="top_section">
      <div id="hide_file">
        Choose File
        <input
          type="file"
          name="image"
          accept="image/*"
          @change="setImage"
        >
      </div>
      <input
        v-model="mailerName"
        type="text"
        placeholder="Enter Mailer Name"
        style="display: inline;"
        name="mailerName"
        required
      >
      <select
        v-model="fascia"
        style="display: inline;"
        @change="fasciaChange()"
      >
        <option value>
          Select Fascia
        </option>
        <option
          v-for="(fascias, key) in fasciasList"
          :key="key"
          :value="fascias._id"
        >
          {{ fascias.fasica_name }}
        </option>
      </select>
      <select
        v-model="category"
        style="display: inline;"
        @change="categoryChange()"
      >
        <option value>
          Select Category
        </option>
        <option
          v-for="(cate, key) in categories"
          :key="key"
          :value="cate"
        >
          {{ getCategoryName(cate) }}
        </option>
      </select>
      <a
        class="button_create"
        @click="saveMailer()"
      >Save</a>
    </div>
    <div class="notes">
      <p>
        Please upload asset with dimensions not more than 600px width,
        so please double check before uploading the asset.
      </p>
      <p>Please exclude .(dot) from the title when saving the template.</p>
    </div>
    <div class="image-decorator">
      <div
        v-show="isUploaded"
        style="width: 600px; margin: auto;"
        @touchmove="prevent"
        @contextmenu="handler($event)"
      >
        <img
          v-show="showPreview"
          id="imgCrop"
          alt="Image principale"
          :src="imagePreview"
        >
      </div>
    </div>
    <br>
    <br>
    <div
      id="selectedID"
      style="display: none;"
    />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Loading from '@/components/loading.vue';

const $ = require('jquery');

window.jQuery = $;
let currentSel = '';
function debugQtyAreas(event, id, areas) {
  $('#selectedID').attr('data-id', id);
  $.each(areas, (sid, area) => {
    if (area.id === id) {
      currentSel = area;
    }
  });
}
require('../assets/jquery.selectareas.js');
require('../assets/resources/jquery.selectareas.css');

export default {
  name: 'SliceToMailers',
  components: {
    Loading,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      userID: '',
      roleID: '',
      isCtxMenu: false,
      imgSrc: '',
      cropImg: '',
      isProgress: false,
      xCoords: '',
      yCoords: '',
      sliceCount: 1,
      isPopup: false,
      imageName: '',
      mailerName: '',
      rowsData: [],
      slicersData: [],
      fasciaTemplate: '',
      fascia: '',
      isUploaded: false,
      category: '',
      fasciasList: [],
      categories: [],
      cropperList: [],
      showPreview: false,
      imagePreview: '',
      slicedImg: [],
      canvas: '',
      context: '',
      imageObj: '',
      categoryList: [],
    };
  },
  created() {
    this.$eventHub.$on('userData', this.getCurrentUser);
  },
  beforeDestroy() {
    this.$eventHub.$off('userData');
  },
  mounted() {
    this.getCurrentUser();
    const getCategories = fetch('/api/categorylist/all', {
      credentials: 'same-origin',
    });
    getCategories
      .then(data => data.json())
      .then((data) => {
        this.categoryList = data;
      });
  },
  methods: {
    getCurrentUser(userData) {
      // you don't have to pass it again from the listener.
      if (userData) {
        this.roleID = userData.role_id;
        this.userID = userData.id;
        if (this.roleID === 2 || this.roleID === 3) {
          const getfascias = fetch('/api/fascias/all', {
            credentials: 'same-origin',
          });
          getfascias
            .then(data => data.json())
            .then((data) => {
              this.fasciasList = data;
            });
        } else {
          const getProfile = fetch(`/api/users/${this.userID}`, {
            credentials: 'same-origin',
          });
          getProfile
            .then(data => data.json())
            .then((data) => {
              this.fasciasList = data.fascias;
            });
        }
      }
    },
    prevent() {},
    hideCtxMenu() {
      this.isCtxMenu = false;
    },
    fasciaChange() {
      if (this.fascia === '') {
        this.categories = [];
        return false;
      }
      const getfascias = fetch(`/api/templateCategories/${this.fascia}`, {
        credentials: 'same-origin',
      });
      getfascias
        .then(data => data.json())
        .then((data) => {
          this.categories = [];
          data.forEach((cat) => {
            this.categories.push(cat.category);
          });
        });
      return true;
    },
    categoryChange() {
      if (this.category === '') {
        this.fasciaTemplate = [];
        return false;
      }
      const template = fetch(
        `/api/fasciaTemplatesByfacia/${this.fascia}/${this.category}`,
        { credentials: 'same-origin' },
      );
      template
        .then(data => data.json())
        .then((data) => {
          this.fasciaTemplate = data[0]._id;
        });
      return true;
    },
    getCategoryName(id) {
      const filteredCategory = this.categoryList.filter(
        category => category._id === id,
      );
      return filteredCategory[0].categoryName;
    },
    handler(e) {
      e.preventDefault();
      this.xCoords = e.pageX;
      this.yCoords = e.pageY;
      this.isCtxMenu = true;
    },
    clearCrop(index) {
      this.cropperList.splice(index, 1);
      this.slicersData.splice(index, 1);
    },
    showPopup() {
      this.isPopup = true;
    },
    sliceRow() {},
    cancel() {
      this.isPopup = false;
    },
    sliceToCrop() {
      this.isPopup = false;
      const slices = this.sliceCount;
      this.isCtxMenu = false;
      const selectedId = $('#selectedID').attr('data-id');
      const curSelector = currentSel;
      $('img#imgCrop').selectAreas('remove', selectedId);
      for (let slice = 0; slice < slices; slice += 1) {
        const cropperJson = {
          y: curSelector.y,
          x: curSelector.x + slice * (curSelector.width / slices),
          width: curSelector.width / slices,
          height: curSelector.height,
        };
        $('img#imgCrop').selectAreas('add', cropperJson);
      }
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes('image/')) {
        this.$toasted.success('Please select an image file', {
          duration: 3000,
        });
        return;
      }
      this.isUploaded = true;
      this.imageName = file.name
        .split('.')
        .slice(0, -1)
        .join('.');
      this.mailerName = this.imageName;
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.showPreview = true;
          this.imagePreview = reader.result;
          // rebuild cropperjs with the updated source
          // this.$refs.cropper.replace(event.target.result)
          setTimeout(() => {
            $('img#imgCrop').selectAreas({
              minSize: [10, 10],
              width: 600,
              onChanged: debugQtyAreas,
            });
          }, 500);
        };
        reader.readAsDataURL(file);
      } else {
        this.$toasted.error('Sorry, FileReader API not supported', {
          duration: 3000,
        });
      }
    },
    groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
    },
    saveMailer() {
      if (this.isUploaded === false) {
        this.$toasted.error('Please Select Image To Crop', { duration: 3000 });
        return true;
      }
      if (this.mailerName === '') {
        this.$toasted.error('Please Enter Mailer Name', { duration: 3000 });
        return true;
      }
      if (this.fascia === '') {
        this.$toasted.error('Please select fascia', { duration: 3000 });
        return true;
      }
      if (this.category === '') {
        this.$toasted.error('Please select Category', { duration: 3000 });
        return true;
      }
      const areas = $('img#imgCrop').selectAreas('relativeAreas');
      if (!areas.length > 0) {
        this.$toasted.error('Please crop the image before saving', {
          duration: 3000,
        });
        return true;
      }
      this.isProgress = true;
      const slicerCopy = [];
      const slicersData = this.groupBy(areas, 'y');
      Object.entries(slicersData).forEach(([key]) => {
        if (slicersData[key].length > 1) {
          for (let j = 0; j < slicersData[key].length; j += 1) {
            slicerCopy.push(slicersData[key][j]);
          }
        } else {
          slicerCopy.push(slicersData[key][0]);
        }
      });
      const img = document.getElementById('imgCrop');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      let imagesArray = [];
      imagesArray = slicerCopy.map((area, i) => {
        canvas.width = area.width;
        canvas.height = area.height;
        context.drawImage(
          img,
          area.x,
          area.y,
          area.width,
          area.height,
          0,
          0,
          area.width,
          area.height,
        );
        const pngUrl = canvas.toDataURL();
        const obj = {
          name: `${this.imageName}_${i}`,
          img: `${pngUrl}`,
        };
        return obj;
      });
      const url = '/api/uploadFile';
      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify({ images: imagesArray }), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then((response) => {
          this.saveImages(response.data);
        });
      return true;
    },
    saveImages(imageArray) {
      const areas = $('img#imgCrop').selectAreas('relativeAreas');
      const slicersData = this.groupBy(areas, 'y');
      let imageIndex = 0;
      let blockIndex = 0;
      Object.entries(slicersData).forEach(([key]) => {
        const blocks = [];
        if (slicersData[key].length > 1) {
          for (let j = 0; j < slicersData[key].length; j += 1) {
            blocks.push({
              id: j,
              name: '',
              url: '',
              imageurls: imageArray[imageIndex],
            });
            imageIndex += 1;
          }
        } else {
          blocks.push({
            id: imageIndex,
            name: '',
            url: '',
            imageurls: imageArray[imageIndex],
          });
          imageIndex += 1;
        }
        this.rowsData.push({ id: blockIndex, blocks });
        blockIndex += 1;
      });
      let url = '/api/createMailer';
      const inputData = {
        fasciaId: this.fascia,
        templateId: this.fasciaTemplate,
        templateCategory: this.category,
        mailerName: this.mailerName,
        mailerJson: JSON.stringify(this.rowsData),
      };
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/createMailer/${this.$route.query.id}`;
      }
      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(inputData), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then((response) => {
          this.isProgress = false;
          this.$toasted.success(response.message, { duration: 3000 });
          this.$router.push({
            name: 'CreateMailer',
            query: { id: response.id },
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cropper-container {
  width: 400px;
  height: 2080px;
  border: 1px solid gray;
  display: inline-block;
  margin-left: 20%;
}

.cropped-area {
  background-color: rgba(0, 0, 222, 0.5);
  position: absolute;
  outline: 1px dotted blue;
  z-index: 111;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: #f1f1f1;
}

.popup-content {
  margin: auto;
  margin-top: 10%;
  width: 20%;
  border-radius: 10px;
  background-color: white;
  height: 200px;
}

.popup-fields {
  margin: auto;
  position: relative;
  top: 65px;
  width: 50%;
}

.btns-container {
  margin-top: 5%;
}

li a {
  display: block;
  color: #000;
  padding: 8px 16px;
  text-decoration: none;
}

li a.active {
  background-color: #4caf50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #555;
  color: white;
}

.slice_mailer input[type="text"],
.slice_mailer input[type="file"] {
  display: inline-block;
}

#hide_file {
  padding: 10px;
  background: #337ab7;
  border: 1px solid #337ab7;
  position: relative;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
}

#hide_file input[type="file"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.top_section {
  text-align: center;
}
.notes {
  text-align: center;
  color: red;
  font-size: 11px;
  font-style: italic;
}
.slices_number {
  width: auto;
  display: inline-block;
}
</style>
